type WindowWithLogging = Window & {
	__LOCATION_SELECT_ENABLE_LOGGING__: boolean;
};

declare const window: WindowWithLogging;

type LogLevel = 'debug' | 'info' | 'warn' | 'error';
type LogFunction = (...args: unknown[]) => void;
type Logger = {
	debug: LogFunction;
	info: LogFunction;
	warn: LogFunction;
	error: LogFunction;
};

try {
	window.__LOCATION_SELECT_ENABLE_LOGGING__ =
		process.env.STORYBOOK_ENABLE_LOGGING === 'true';

	if (window.__LOCATION_SELECT_ENABLE_LOGGING__) {
		console.info(
			'[LocationSelect]',
			'Logging for the LocationSelect component is enabled.',
		);
	} else {
		// Add a message to instruct developers how to enable logging
		console.info(
			'[LocationSelect]',
			'To enable logging for the LocationSelect component, run this command in the console:',
			'window.__LOCATION_SELECT_ENABLE_LOGGING__ = true',
		);
	}
} catch {
	// If there's an error (e.g., running in a non-browser environment), keep logging disabled
	console.warn(
		'[LocationSelect]',
		'Unable to determine logging status, defaulting to disabled',
	);
}

function isLoggingEnabled(): boolean {
	return window.__LOCATION_SELECT_ENABLE_LOGGING__;
}

function log(
	doLog: LogFunction,
	level: LogLevel,
	prefix?: string,
	...args: unknown[]
): void {
	if (!isLoggingEnabled()) {
		return;
	}

	doLog(`[LocationSelect|${level}]${prefix ? ` [${prefix}]` : ''}`, ...args);
}

export function createLogger(prefix?: string): Logger {
	const logger: Logger = {
		debug: (...args: unknown[]) => log(console.debug, 'debug', prefix, ...args),
		info: (...args: unknown[]) => log(console.log, 'info', prefix, ...args),
		warn: (...args: unknown[]) => log(console.warn, 'warn', prefix, ...args),
		error: (...args: unknown[]) => log(console.error, 'error', prefix, ...args),
	};

	return Object.freeze(logger);
}

export default createLogger();
